import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SessionsPage } from '@/features/sessions/session-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Sessions interactives du tenant (ADR 0042 §5). */
export const Route = createFileRoute('/$tenant/sessions/')({ component: SessionsRoute });

function SessionsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="sessions" crumbs={[{ label: t('sessions.title') }]}>
      <SessionsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
